import {types} from './report.actions';

const initialState = {
    roteirizador: { 
        countCargasCriadas: 0, 
        filters: {
            carrier: {
                documentNumber: null,
                name: "TODOS",
            },
            period: {
                description:"Últimos 7 dias",
                period: "LAST_SEVEN_DAYS"
            },
        },
        lookup:{
            showCarrier: false,
            showPeriod: false,
            columnsCarrier:[
                {
                    field: "razaoSocial",
                    header: "Razão social",
                    columnKey: "razaoSocial",
                    sortable: false,
                    filter: true
                   
                  }
            ],
            columnsPeriod:[
                {
                    field: "description",
                    header: "Período",
                    columnKey: "description",
                    sortable: false,
                    filter: true
                   
                  }
            ]
        }
    }
}

export function reducerRoteirizadorIndicator(state = initialState, action){
    let result = state;
    switch(action.type){
        case types.SET_VALUE:
            return setValue(state, action);
        case types.SET_NAME:
            return setName(state, action);
        case types.SET_CNPJ:
            return setCNPJ(state, action);
        case types.SET_PERIOD:
            return setPeriod(state, action);
        case types.SET_SHOW_CARRIER:
            return setShowCarrier(state, action);
        case types.SET_SHOW_PERIOD:
            return setShowPeriod(state, action);   
        case types.LOADER_SHOW:
            return loaderShow(state, action);
        case types.LOADER_HIDDEN:
            return loaderHide(state, action);                   
        default:
        return result; 
    }
}

function setValue(state, action){
    const roteirizador = {...state.roteirizador, countCargasCriadas:action.value}
    return Object.assign({}, state, {roteirizador});
}

function setName(state, action){
    return Object.assign({}, state, { value: action.name }); 
}

function setCNPJ(state, action){
    const filters = {...state.roteirizador.filters,carrier:action.carrier}
    const roteirizador = {...state.roteirizador, filters}
    return Object.assign({}, state, {roteirizador}); 
}

function setPeriod(state, action){
    const filters = {...state.roteirizador.filters, period:action.period}
    const roteirizador = {...state.roteirizador, filters}
    return Object.assign({}, state, {roteirizador});  
}

function setShowCarrier(state, action){
    const lookup = {...state.roteirizador.lookup, showCarrier:action.showCarrier}
    const roteirizador = {...state.roteirizador, lookup}
    return Object.assign({}, state, {roteirizador}); 
}

function setShowPeriod(state, action){
    const lookup = {...state.roteirizador.lookup, showPeriod:action.showPeriod}
    const roteirizador = {...state.roteirizador, lookup}
    return Object.assign({}, state, {roteirizador}); 
}

function loaderShow(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

function loaderHide(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

